module.exports = __webpack_public_path__ + "img/header-slide-720-2@2x.808877a7.png";